export enum AppGame {
  LOL = "lol",
  VALORANT = "valorant",
}

export const EAppGames = {
  LOL: AppGame.LOL,
  VALORANT: AppGame.VALORANT,
} as const;
